module.exports = __webpack_public_path__ + "static/media/golfer-8-a.b7e5f1b5.png";